import { Element } from "./Element.mjs";
import { Text } from "./Text.mjs";
export var Node;

(function (Node) {
  function isNode(value) {
    return Text.isText(value) || Element.isElement(value);
  }

  Node.isNode = isNode;
})(Node || (Node = {}));